export { default, default as EquipmentInfoSection } from './EquipmentInfoSection';
